module.exports = __webpack_public_path__ + "58e6a155d9a5208b49bcd8b6e3e21058.svg";